import { ReferenceInput, AutocompleteInput, required, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { contractorFilterToQuery } from '@/helpers/filters/filterToQuery';
import { useFormContext } from 'react-hook-form';

export const ContractorSelect = () => {
    const translate = useTranslate();
    const { setValue } = useFormContext();
    const handleChange = () => {
        setValue('collectionPointId', null);
        setValue('groupId', null);
    };

    return (
        <Box className='autocomplete-parent'>
            <ReferenceInput source='contractorId' reference='contractor' label={translate('common.contractor')} perPage={25}>
                <AutocompleteInput
                    filterToQuery={contractorFilterToQuery}
                    validate={required(translate('common.validation.required'))}
                    fullWidth
                    onChange={handleChange}
                    disablePortal={true}
                    label={translate('common.contractor')}
                />
            </ReferenceInput>
        </Box>
    );
};
